import React from 'react';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import GenericInput from './GenericInput';
import { GoogleApiWrapper } from 'google-maps-react';

class LocationSearchInput extends React.Component {
    constructor(props) {
        super(props);
        const { address } = this.props;
        this.state = {
            invalidInput: false,
            address: address && address.longAddress ? address.longAddress : '',
            errorMessage: '',
            latitude: null,
            longitude: null,
            isGeocoding: false
        };
        this.toggleManualAddress = this.toggleManualAddress.bind(this);          
    }

    handleChange = address => {       
        this.setState({
            address,
            latitude: null,
            longitude: null,
            errorMessage: ''
        });

        // note: this works, but the control doesn't behave well when making this call on every onChange...
        //geocodeByAddress(address)
        //    .then(res => { let comp = this.getAddressComponents(res); console.log("handleChange", comp); });

        if (this.props.onChange) {
            this.props.onChange(address);
        }
    };

    toggleManualAddress() {        
        if (this.props.notifyToEnterAddressManually) {
            this.props.notifyToEnterAddressManually();
        }
    }

    getAddressComponents(geo, address) {

        let streetNumber = "", street = "", city = "", state = "", zip = "";

        for (var i = 0; i < geo[0].address_components.length; i++) {
            let comp = geo[0].address_components[i];

            if (comp.types.indexOf("street_number") >= 0) {
                streetNumber = comp.long_name;
            }

            if (comp.types.indexOf("route") >= 0) {
                street = comp.long_name;
            }

            if (comp.types.indexOf("locality") >= 0) {
                city = comp.long_name;
            }

            //Since we are save state short name while enter the address manually.
            if (comp.types.indexOf("administrative_area_level_1") >= 0) {
                state = comp.short_name;
            }

            if (comp.types.indexOf("postal_code") >= 0) {
                zip = comp.long_name;
            }
        }

        if (street && city && state && zip) {
            return {
                streetNumber: streetNumber,
                street: street,
                city: city,
                state: state,
                zip: zip,
                longAddress: address ? address : ""
            };
        } else {
            this.setState({ errorMessage: "Address is incomplete. Try again or " });
            return null;
        }
       
    }

    handleSelect = selected => {        
        this.setState({ isGeocoding: true, address: selected });
        geocodeByAddress(selected)
            .then(res => { return this.getAddressComponents(res, selected); })
            .then(components => {
                if (this.props.onChange) {
                    this.props.onChange(selected, components);
                }
            })
            .catch(error => {
                this.setState({ isGeocoding: false });
            });
    };

    handleCloseClick = () => {
        this.setState({
            address: '',
            latitude: null,
            longitude: null,
            invalidInput: true,
        });
        this.props.onChange();
    };

    handleError = (status, clearSuggestions) => {
        if (status === "ZERO_RESULTS") {
            this.setState({ errorMessage: "Address not found. Try again or " }, () => {
                clearSuggestions();
            });
        }
        else {
            this.setState({ errorMessage: "Unable to retrieve address details. Try again or " }, () => {
                clearSuggestions();
            });
        }       

    };

    onBlur = (suggestions) => {        
        const activeSuggestion = suggestions && suggestions.find(suggestion => suggestion.active); // Selecting the active suggestion on Blur
        if (activeSuggestion && activeSuggestion.description) {
            this.handleSelect(activeSuggestion.description);
        }       

        if (this.props.required && !this.state.address) {
            this.setState({ invalidInput: true });
            //Triggering this event due to show the inValidInput
            this.props.onChange();
        }
        else
            this.setState({ invalidInput: false });
    }

    render() {
        const {
            address,
            errorMessage,
            latitude,
            longitude,
            isGeocoding
        } = this.state;

        const { required, showAsInvalid , disableAutoSuggest = true} = this.props;

        return (
            <PlacesAutocomplete
                onChange={this.handleChange}
                value={address}
                onSelect={this.handleSelect}                
                onError={this.handleError}
                shouldFetchSuggestions={address.length > 2}
                highlightFirstSuggestion
                ref="places"
            >
                {({ getInputProps, suggestions, getSuggestionItemProps }) => {
                    return (
                        <div className={"il-group location-search-group" + (address ? " input-not-empty" : "") + (errorMessage.length || this.state.invalidInput || showAsInvalid ? " input-invalid" : "")}>
                            <div className="location-search-input-container">
                                <input aria-label={this.props.placeholder ? this.props.placeholder : 'Mailing Address'}
                                    {...getInputProps({
                                        id: this.props.id ? this.props.id : '',
                                        placeholder: this.props.placeholder || 'Mailing Address',
                                        className: 'location-search__input form-control',
                                        required: required,
                                        onBlur: this.onBlur.bind(this, suggestions),
                                        autoComplete: disableAutoSuggest ? "bswh-location-search" : "on" //adding a random string instead of "off" as per the bug https://bugs.chromium.org/p/chromium/issues/detail?id=468153#c29 and the suggestion by zkoch@chromium.org
                                })}
                                    ref="inputElement"
                                />
                                {this.state.address.length > 0 && (
                                    <button 
                                        className="clear-btn"
                                        onClick={this.handleCloseClick}
                                        aria-label="Clear button"
                                    >
                                        <span className="icon-input-clear" />
                                    </button>
                                )}
                                <div className="il-label" aria-hidden="true">
                                    {this.props.placeholder ? this.props.placeholder : "Mailing Address"}
                                </div>
                                {errorMessage.length > 0 && (
                                    <div className="input-error-msg">{this.state.errorMessage}
                                        <span className="link-style" onClick={this.toggleManualAddress}>click here to enter address manually.</span>
                                    </div>
                                    
                        )}
                            </div>
                            {suggestions.length > 0 && (
                                <div className="location-search__suggestions">
                                    {suggestions.map(suggestion => {
                                        const className = suggestion.active ? "suggestion-item suggestion-highlighted" : "suggestion-item";
                                        var mainText = suggestion.formattedSuggestion.mainText;
                                        var subText = suggestion.formattedSuggestion.secondaryText;
                                        var spanInsertBegin = "<span class='matched-text'>";
                                        var spanInsertEnd = "</span>";

                                        if (suggestion.matchedSubstrings.length > 0) {
                                            // Reverse order of matched substring array so position can stay accurate when inserting spans
                                            suggestion.matchedSubstrings.slice(0).reverse().map(subString => {
                                                // Sets position of closing span
                                                var newPositionEnd = subString.offset + subString.length;

                                                // If substring is longer than maintext length then insert spans in subtext
                                                if (subString.offset <= mainText.length) {
                                                    mainText = [mainText.slice(0, subString.offset), spanInsertBegin, mainText.slice(subString.offset, newPositionEnd), spanInsertEnd, mainText.slice(newPositionEnd)].join('');
                                                }
                                                else {
                                                    // Subtract maintext length so position is relevant to subtext length
                                                    var subPositionOffset = subString.offset - (mainText.length + 2);
                                                    var subPositionEnd = subPositionOffset + subString.length;
                                                    subText = [subText.slice(0, subPositionOffset), spanInsertBegin, subText.slice(subPositionOffset, subPositionEnd), spanInsertEnd, subText.slice(subPositionEnd)].join('');
                                                }
                                            });
                                        }
                            return (
                                /* eslint-disable react/jsx-key */
                                <div
                                    {...getSuggestionItemProps(suggestion, { className })}
                                >
                                                <span className="icon-address" />
                                                <span className="suggestion-item__main" dangerouslySetInnerHTML={{ __html: mainText }} />{' '}
                                                <span className="suggestion-item__sub" dangerouslySetInnerHTML={{ __html: subText }} />
                                            </div>
                                        );
                                        /* eslint-enable react/jsx-key */
                                    })}
                                    {
                                        <div className="location-search__footer">
                                            <div className="google-powered-img">
                                                <img alt="powered by google default" src="/images/powered_by_google_default.png"
                                                    className="img-fluid"
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>
                            )}
                        </div>
                    );
                }}
            </PlacesAutocomplete>
        );
    }
}

const wrapped = GoogleApiWrapper((props) => ({
    apiKey: window.serverData.data.googleMapKey
}))(LocationSearchInput);

export default wrapped;
